/**
 * @module builder
 */
import type { QuoteDocument } from 'paintscout'

import type { QuoteItemView, QuoteItemSection, UpdateableItem } from '../../index'

import differenceBy from 'lodash/differenceBy'
import type { RenderableItem } from '..'

export function reorderItems(args: {
  quote: QuoteDocument
  items: Array<UpdateableItem | RenderableItem>
  view: QuoteItemView
  section: QuoteItemSection
}): QuoteDocument {
  const { quote, items, view, section } = args

  const orderItems = items.map((item) => {
    return {
      type: item.type,
      key: item.key
    }
  })

  let existingOrder
  let orderKey
  if (view === 'area') {
    if (section === 'options') {
      existingOrder = quote.order?.areaOptions ?? []
      orderKey = 'areaOptions'
    } else if (section === 'archived') {
      existingOrder = quote.order?.areaArchived ?? []
      orderKey = 'areaArchived'
    } else {
      existingOrder = quote.order?.area ?? []
      orderKey = 'area'
    }
  } else if (view === 'substrate') {
    if (section === 'options') {
      existingOrder = quote.order?.substrateOptions ?? []
      orderKey = 'substrateOptions'
    } else if (section === 'archived') {
      existingOrder = quote.order?.substrateArchived ?? []
      orderKey = 'substrateArchived'
    } else {
      existingOrder = quote.order?.substrate ?? []
      orderKey = 'substrate'
    }
  } else {
    return {
      ...quote
    }
  }

  const otherItems = differenceBy(existingOrder, orderItems, 'key')

  const updatedQuote = {
    ...quote,
    order: {
      ...quote.order,
      [orderKey]: [...orderItems, ...otherItems]
    }
  }

  return updatedQuote
}

// /*
//   area: OrderItem[]
//   areaOptions?: OrderItem[]
//   areaArchived?: OrderItem[]
//   substrate: OrderItem[]
//   substrateOptions?: OrderItem[]
//   substrateArchived?: OrderItem[]
//   crew?: OrderItem[]
// */
